module.exports = "/_next/static/images/sedan-2d161e3b6b5e0232019da217b5d63bb6.jpg";